import { createElement } from "@max/max";
import { getFullScreenSize } from "@/utils/layout";
import ModalBaseContainer from '@max/leez-modal-base-container';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import LImage from '@max/leez-image';
import TopView from '@max/leez-top-view';
import ModalBottomBtn from "../modal-bottom-button";
import './index.scss';
export default function FreeCardFailPopup(props) {
    const { fullScreenHeight } = getFullScreenSize();
    const handleTeamPress = () => {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.onTeamPress) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    return <TopView>
      <ModalBaseContainer visible={props.visible} contentStyle={{
        width: '750rpx',
        height: fullScreenHeight,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
    }}>
        
        <LImage source={{
        uri: 'https://p0.meituan.net/ingee/a8061a9cdba4a6f9169312dedcc5591f11238.png'
    }} style={{
        width: '564rpx',
        height: '512rpx',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative'
    }}>
          
          <View className="free-card-fail-container">
            
            <View className="free-card-fail-content">
              <Text className="free-card-fail-text">再抽一次</Text>
              <Text x-if={props.inTeam} className="free-card-fail-desc">邀好友打Call，可赢抽免单次数！</Text>
              <Text x-else className="free-card-fail-desc">参与组队打Call活动，可赢抽免单次数！</Text>
            </View>

            
            <View style={{
        marginTop: '85rpx'
    }}>
              <ModalBottomBtn buttonText={props.inTeam ? '邀好友来打Call' : '立即参与'} onPress={handleTeamPress}/>
            </View>
          </View>
        </LImage>

        
        <LImage onPress={props.onClose} source={{
        uri: 'https://p0.meituan.net/ingee/94047ffc6fa8ede65644e7a2653da1691779.png'
    }} style={{
        width: '48rpx',
        height: '48rpx',
        marginTop: '115rpx'
    }} className="free-card-fail-close-btn"/>
      </ModalBaseContainer>
    </TopView>;
}
